export const PAY_DURATIONS = {
  SINGLE_PAY: 1,
  AGE_65: -65,
  LIFETIME: -1,
};
